import React from 'react';
import Project from '../../components/Project';

export default ({ location }) => <Project location={location} projectName="Visual experiment" />;
